import { useState } from "react";
import { Box, styled, Checkbox, FormControlLabel } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AuthenticateLayout from "../../components/AuthenticateLayout";
import ChangeLanguage from "../../components/ChangeLanguage";
import { ENV } from "../../configs/env";
import { SubmitButton } from "./components/styles";

import { updatePaypayConsent } from "../../services/ads/ads.service";
import { links } from "../../constants/links";


const Wrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "-webkit-fill-available"
});

const TextWrapper = styled(Box)({
    fontSize: 16,
    color: "#0f3a65ff",
    textAlign: "center",
    lineHeight: 2,
    whiteSpace: "pre-line",
});


const PaypayConsent: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { engageSession, couponSession } = location.state || {};
    const [checked, setChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitPaypay = async () => {
        if (!couponSession || !engageSession) {
            console.error("coupon session and engageSession are required");
            navigate(`${links.SMART_RETAIL_ERROR}/?error-msg=invalid_request`);
            return;
        }

        try {
            setIsSubmitting(true);

            const res = await updatePaypayConsent({ couponSession });

            if (res.status === 200) {
                navigate(
                    `${links.USE_REWARD_V2}/?engage-session=${engageSession}&coupon-session=${couponSession}`,
                    { state: { isFromPaypayConsentPage: true } }
                );
            } else {
                console.error("Consent failed", res);
                navigate(`${links.SMART_RETAIL_ERROR}/?error-msg=invalid_request`);
            }
        } catch (err) {
            console.error("Consent failed", err);
            navigate(`${links.SMART_RETAIL_ERROR}/?error-msg=invalid_request`);
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <Wrapper>
            <AuthenticateLayout
                hideBackground={true}
                button={() => !ENV.HIDE_TRANSLATOR && <ChangeLanguage />}
                isLoading={isSubmitting}
                hideLogo={ENV.HIDE_LOGO}
            >
                <Box
                    px={4}
                    mt={3}
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                >
                    <TextWrapper
                        sx={{
                            fontSize: 18,
                            fontWeight: 600,
                            paddingTop: 3,
                            paddingBottom: 5
                        }}
                    >
                        {t("paypay_main_text")}
                    </TextWrapper>
                    <FormControlLabel
                        sx={{
                            paddingTop: 10,
                            alignItems: "flex-start"
                        }}
                        control={
                            <Checkbox
                                name="paypayConsent"
                                checked={checked}
                                onChange={(e) => setChecked(e.target.checked)}
                            />
                        }
                        label={
                            <TextWrapper
                                sx={{
                                    fontSize: 20,
                                    fontWeight: 600
                                }}
                            >{t("agree_paypay")}
                            </TextWrapper>
                        }
                    />
                    <Box
                        sx={{
                            paddingTop: 5
                        }}
                    >
                        <SubmitButton
                            disabled={!checked || isSubmitting}
                            sx={{
                                whiteSpace: "pre-line"
                            }}
                            onClick={submitPaypay}
                        >
                            {t("submit_paypay")}
                        </SubmitButton>
                    </Box>
                </Box>
            </AuthenticateLayout>
        </Wrapper>
    );
};

export default PaypayConsent;

